<template>
    <div>
        <div class="row mb-3">
            <div class="col-12">
                <el-alert
                    v-if="showStatus"
                    :title="statusMessage"
                    :type="status ? 'success' : 'error'"
                    effect="dark"
                    class="w-100"
                ></el-alert>
            </div>
        </div>
        <div class="card shadow-lg rounded-card option-card white-card mt-0" style="max-width: 600px">
            <div class="card-body">
                <div v-if="googleChart" class="input-belt mb-4">
                    <label>You must setup Two Factor Authentication to continue</label>
                    <p>Download the Google Authenticator app and scan the QR code below to setup two factor authenticator.</p>
                    <img :src="googleChart" style="width: 150px; margin: auto" />
                </div>

                <div class="input-belt">
                    <label>Complete logging in with the authenticator app</label>
                    <p v-if="googleChart">Enter the 6-digit code provided by the authenticator app.</p>
                    <input
                        type="text"
                        class="my-3"
                        v-model="code"
                        @keydown="clearErrors"
                        @keydown.enter="verify"
                        placeholder="Enter six-digit code"
                        :disabled="loading"
                    />
                    <div class="d-flex justify-content-between">
                        <el-button class="w-50 mr-3" type="success" @click="verify" :loading="loading">Verify</el-button>
                        <el-button class="w-50 ml-3" type="warning" @click="cancel" :disabled="loading">Cancel</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        redirectLink: {
            required: true,
            type: String,
        },
        user: {
            type: Object,
            required: true,
        },
        loginUrl: {
            type: String,
            required: true,
        },
        googleChart: {
            required: true,
            type: String,
        },
        userToken: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            code: null,
            status: null,
            showStatus: false,
            statusMessage: "",
            loading: false,
            loadDelay: 0,
        }
    },
    methods: {
        async cancel() {
            window.location.href = `/logout`
        },
        verify() {
            this.loading = true
            axios
                .post(this.loginUrl,
                    { code: this.code},
                    {
                        headers: {
                        'Authorization': `Bearer ${this.userToken}`
                    }})
                .then(res => {
                    this.status = true
                    this.showStatus = false
                    this.statusMessage = "Verified"
                    location.href = `${this.redirectLink}`
                })

            setTimeout(() => {
                this.loading = false
            }, this.loadDelay)
        },
        clearErrors() {
            this.showStatus = false
        },
    },
}
</script>
